import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Login } from "@src/page/loginPage/login.page";
import { Report } from "@src/page/reportPage/report.page";
import { DutyRequest } from "@src/page/dutyRequestPage/dutyRequest.page";
import { Dashboard } from "@src/page/dashboardPage/dashboard.page";
import { Incidents } from "@src/page/incidentPage/incident.page";
import { IncidentDetail } from "@src/page/incidentPage/incidentDetail.page";
import { Roster } from "@src/page/rosterPage/roster.page";
import { ServiceReport } from "@src/page/serviceReportPage/serviceReport.page";
import { Invoices } from "@src/page/invoicePage/invoice.page";
import { InvoiceView } from "@src/page/invoicePage/invoiceView.page";
import { RosterPrint, ServicePrint } from "@src/page/printPage/print.page";
import { privateClient, publicClient } from "./config/apollo";
import { ApolloProvider } from "@apollo/client";
import { Password } from "./page/loginPage/password.page";
import { PrivateRoutes } from "./util/privateRoute/privateRoute";

const App = () => {
    return (
        <BrowserRouter>

            <ApolloProvider client={publicClient}>
                <Routes>
                    {localStorage.getItem('authToken')
                        ? <Route path='/' element={<Navigate to={"/customer"} />} />
                        : <Route path="/" element={<Login />} />
                    }
                    <Route path="/verify" element={<Password />} />
                </Routes>
            </ApolloProvider>

            <ApolloProvider client={privateClient}>
                <Routes>

                    <Route
                        path="/customer"
                        element={<PrivateRoutes><Dashboard /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/reports"
                        element={<PrivateRoutes><Report /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/reports/:siteId"
                        element={<PrivateRoutes><Report /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/duty-requests"
                        element={<PrivateRoutes><DutyRequest /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/incidents"
                        element={<PrivateRoutes><Incidents /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/incidents/:incidentId"
                        element={<PrivateRoutes><IncidentDetail /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/schedule"
                        element={<PrivateRoutes><Roster /></PrivateRoutes>}
                    />

                    {/* the Schedule page's earlier address - links and bookmarks keep working */}
                    <Route
                        path="/customer/roster"
                        element={<PrivateRoutes><Roster /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/service-report"
                        element={<PrivateRoutes><ServiceReport /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/invoices"
                        element={<PrivateRoutes><Invoices /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/invoices/:invoiceId"
                        element={<PrivateRoutes><InvoiceView /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/print/service"
                        element={<PrivateRoutes><ServicePrint /></PrivateRoutes>}
                    />

                    <Route
                        path="/customer/print/roster"
                        element={<PrivateRoutes><RosterPrint /></PrivateRoutes>}
                    />

                </Routes>
            </ApolloProvider>

        </BrowserRouter>
    );
};

export default App;
